import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Web3Provider } from './contexts/Web3Context';
import PresaleWidget from './components/PresaleWidget';

// Support embedding the widget into an external page that has an element with id="presale-widget-root"
const presaleMount = document.getElementById('presale-widget-root');
if (presaleMount) {
  const widgetRoot = ReactDOM.createRoot(presaleMount);
  widgetRoot.render(
    <React.StrictMode>
      <Web3Provider>
        <PresaleWidget />
      </Web3Provider>
    </React.StrictMode>
  );
}

// Default CRA entry point for the standalone app (uses div#root in public/index.html)
const appMount = document.getElementById('root');
if (appMount) {
  const appRoot = ReactDOM.createRoot(appMount);
  appRoot.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
